import { render, staticRenderFns } from "./BottomNavigationV2.vue?vue&type=template&id=31494752"
import script from "./BottomNavigationV2.vue?vue&type=script&lang=js"
export * from "./BottomNavigationV2.vue?vue&type=script&lang=js"
import style0 from "./BottomNavigationV2.vue?vue&type=style&index=0&id=31494752&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports